import React, { useState } from 'react';
import PromotionService from '../promotion/PromotionService';
import ImageService from '../images/imageService'; // ✅ Import default instance
import './CreatePromotion.css';

const CreatePromotion = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [uploadedFilename, setUploadedFilename] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');

  const promotionService = new PromotionService();

  const handleImageChange = async (e) => {
    const file = e.target.files[0];

    if (!title) {
      setMessage('Please enter a title before uploading an image.');
      return;
    }

    if (file) {
      setUploading(true);
      try {
        const filename = `${title}.png`;
        const uploadedPath = await ImageService.uploadImage(file, filename, 'promotion');

        const uploadedFile = uploadedPath.split('/').pop();
        setUploadedFilename(uploadedFile);
        setPreviewUrl(ImageService.getImageUrl('promotion', uploadedFile));
        setMessage('Image uploaded successfully!');
      } catch (error) {
        console.error('Image upload error:', error);
        setMessage('Failed to upload image.');
      } finally {
        setUploading(false);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !description || !uploadedFilename) {
      setMessage('Please fill in all fields and upload an image.');
      return;
    }

    setUploading(true);
    try {
      const newPromotion = {
        title,
        description,
        picture: uploadedFilename,
        status: 1,
      };

      await promotionService.add(newPromotion);
      setMessage('Promotion created successfully!');

      // Reset form
      setTitle('');
      setDescription('');
      setUploadedFilename('');
      setPreviewUrl('');
    } catch (error) {
      console.error('Error creating promotion:', error);
      setMessage('Failed to create promotion.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="create-promotion-container">
      <h2>Create a New Promotion</h2>
      <form className="create-promotion-form" onSubmit={handleSubmit}>
        <label>Title:</label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Enter promotion title"
          required
        />

        <label>Description:</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Enter promotion description"
          required
        />

        <label>Promotion Image:</label>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          required
        />

        {previewUrl && (
          <div className="image-preview">
            <img src={previewUrl} alt="Promotion Preview" />
          </div>
        )}

        <button type="submit" disabled={uploading}>
          {uploading ? 'Processing...' : 'Create Promotion'}
        </button>

        {message && <p className="message">{message}</p>}
      </form>
    </div>
  );
};

export default CreatePromotion;
